/**
 * 定位并高亮订单 modal / 审批详情里的产品行。
 * 锚点约定：`[data-order-item-index]` / `[data-order-product-code]`（挂在行内元素上）。
 */
export function focusOrderProductRow({ itemIndex, productCode } = {}) {
	const previous = document.querySelectorAll('.order-modal-product-row--highlight');
	previous.forEach((el) => el.classList.remove('order-modal-product-row--highlight'));

	let anchor = null;
	if (Number.isInteger(itemIndex) && itemIndex >= 0) {
		anchor = document.querySelector(`[data-order-item-index="${itemIndex}"]`);
	}
	if (!anchor && productCode) {
		const code = String(productCode).trim();
		if (code) {
			anchor = document.querySelector(`[data-order-product-code="${CSS.escape(code)}"]`);
		}
	}
	if (!anchor) return false;

	const row = anchor.closest('tr') || anchor.closest('[data-order-product-row]') || anchor;
	row.scrollIntoView({ behavior: 'smooth', block: 'center' });
	row.classList.add('order-modal-product-row--highlight');
	window.setTimeout(() => {
		row.classList.remove('order-modal-product-row--highlight');
	}, 2600);
	return true;
}
